<footer class="footer-area footer-modern pt-70 pb-40">
    <div class="footer-glow-1"></div>
    <div class="footer-glow-2"></div>

    <div class="container-fluid p-0">
        <div class="footer-shell">
            <div class="footer-top-panel">
                <div class="row g-4 g-lg-5">
                    <div class="col-lg-4">
                        <div class="footer-widget footer-column footer-brand-panel h-100">
                            <img src="assets/img/lemonmode_logo.png" alt="logo" class="logo-main">
                            <p class="footer-desc mb-4">
                                Global service platform operating across India, Canada, Japan, Germany,
                                Australia, US, UK and more.
                            </p>

                            <h3 class="footer-mini-title">Company</h3>
                            <ul class="footer-links-modern mb-4">
                                <li><a routerLink="/about"><span>About Us</span></a></li>
                                <li><a routerLink="/services"><span>Services</span></a></li>
                            </ul>

                            <div class="footer-social-wrap">
                                <ul class="footer-socials-modern">
                                    <li><a href="https://www.facebook.com" target="_blank"
                                            class="social-btn facebook"><i class='bx bxl-facebook'></i></a></li>
                                    <li><a href="https://twitter.com" target="_blank" class="social-btn twitter"><i
                                                class='bx bxl-twitter'></i></a></li>
                                    <li><a href="https://www.linkedin.com" target="_blank"
                                            class="social-btn linkedin"><i class='bx bxl-linkedin'></i></a></li>
                                    <li><a href="https://www.instagram.com" target="_blank"
                                            class="social-btn instagram"><i class='bx bxl-instagram'></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-5">
                        <div class="footer-widget footer-column footer-newsletter-panel h-100">
                            <h3 class="footer-mini-title">Quick Contact</h3>
                            <p class="footer-desc mb-4">
                                Need shipment support, a service update, or a fast callback? Reach us directly below.
                            </p>

                            <div class="footer-contact-stack">
                                <div class="footer-contact-item">
                                    <i class='bx bx-envelope'></i>
                                    <div>
                                        <span>Email</span>
                                        <a
                                            [href]="displayEmail !== '-' ? 'mailto:' + displayEmail : null">{{displayEmail}}</a>
                                    </div>
                                </div>

                                <div class="footer-contact-item">
                                    <i class='bx bx-phone-call'></i>
                                    <div>
                                        <span>Phone</span>
                                        <a
                                            [href]="displayPhone !== '-' ? 'tel:' + displayPhone : null">{{displayPhone}}</a>
                                    </div>
                                </div>

                                <div class="footer-contact-item">
                                    <i class='bx bx-time-five'></i>
                                    <div>
                                        <span>Hours</span>
                                        <p>Mon - Sat, 9:00 AM to 6:00 PM</p>
                                    </div>
                                </div>
                            </div>

                            <div class="footer-location-modern mt-4">
                                <div class="location-icon">
                                    <i class='bx bxs-location-plus'></i>
                                </div>
                                <span>Worldwide Services</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3">
                        <div class="footer-widget footer-column footer-links-panel h-100">
                            <h3 class="footer-mini-title">Information</h3>
                            <ul class="footer-links-modern">
                                <li><a routerLink="/faq"><span>FAQ’s</span></a></li>
                                <li><a routerLink="/privacy-policy"><span>Privacy Policy</span></a></li>
                                <li><a routerLink="/terms-conditions"><span>Terms & Conditions</span></a></li>
                                <li><a routerLink="/contact"><span>Contact Us</span></a></li>
                                <li><a routerLink="/documentation"><span>Api's</span></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="footer-bottom-bar">
                <span class="footer-bottom-text">Lemonmode</span>
                <span class="footer-bottom-sep"></span>
                <span class="footer-bottom-copy">Global logistics and service solutions designed for reliability.</span>
            </div>
        </div>
    </div>
</footer>
<div class="go-top active">
    <div class="pulse-ring"></div>
    <i class='bx bx-chevrons-up'></i>
</div>